import { useState, useContext, useEffect } from 'react'
import { DataContext } from "../data/DataContext";
import { DropDown } from './DropDown'
import { RadioButton } from './RadioButton'
import { catSiNo, catDamageLevel } from '../data/MochaData'

const VehicleDamageCtrl = (data: IVehicleDamage) => {
    const { ReclamosInspeccionNI, setReclamosInspeccionNI } = useContext(DataContext);
    const [vehicleDamage, setVehicleDamage] = useState(data)

    //const changeRadio = (propierties: string, value: boolean) => setVehicleDamage({ ...vehicleDamage, [propierties]: value });
    const changeCbo = (properties: string, value: string) => {
        setVehicleDamage({ ...vehicleDamage, [properties]: value });
    }

    const changeRadio = (properties: string, value: boolean) => {
        const prop = properties.split('_');
        setVehicleDamage({ ...vehicleDamage, [prop[0]]: value })
    };

    useEffect(() => {

        let lst = ReclamosInspeccionNI.lstVehicleDamage;

        if (lst !== undefined && lst.length > 0) {
            let index = lst.findIndex(x => x.id === vehicleDamage.id);
            if (index !== undefined) {
                lst[index].damageLevel = vehicleDamage.damageLevel;
                lst[index].damageType = vehicleDamage.damageType;
                lst[index].isProductAccident = vehicleDamage.isProductAccident;
                setReclamosInspeccionNI({ ...ReclamosInspeccionNI, lstVehicleDamage: lst });
            }
        }
    }, [vehicleDamage])

    const removeVehicleDamage = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();
        let lst = ReclamosInspeccionNI.lstVehicleDamage;
        let result = lst?.filter(x => x.id !== data.id);
        setReclamosInspeccionNI({ ...ReclamosInspeccionNI, lstVehicleDamage: result });
    }

    return (
        <>
            {data.id !== 1 &&
                <div className='' style={{ display: 'flex' }}>
                    <button className='btn-add-re-ni' style={{ background: "#D43C37" }} onClick={removeVehicleDamage}> - </button>
                </div>
            }
            <DropDown
                id={`damageType_${data.id}`}
                onChangeSelect={changeCbo}
                label='Tipo de daño*'
                field='damageType'
                valueSelect={vehicleDamage.damageType}
                dataProvider={ReclamosInspeccionNI.damageCatalog}
                hasDescription={true}

            />
            <RadioButton
                label='¿Es producto del accidente?*'
                field={`isProductAccident_${data.id}`}
                key={`isProductAccident_${data.id}`}
                value={vehicleDamage.isProductAccident}
                onChange={changeRadio}
                catalog={catSiNo}

            />


            <DropDown
                id={`damageLevel_${data.id}`}
                onChangeSelect={changeCbo}
                label='Nivel de daño*'
                field='damageLevel'
                valueSelect={vehicleDamage.damageLevel}
                dataProvider={catDamageLevel}
                hasDescription={false}

            />

        </>
    )
}

export { VehicleDamageCtrl }